// Module
var code = "<tr> <!-- ko foreach: Cells --> <!-- ko template: { html: $data.GetTemplate.bind($data), afterRender: $data.AfterRender.bind($data) } --><!-- /ko --> <!-- /ko --> </tr>";
// Exports
export default code;